import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Sidebar from "../components/Sidebar";

import {apiPath, serverToken} from "../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";


function Admin() {

    const navigate = useNavigate();

    const [user, setUser] = useState(null)
    const [isLoggedIn, setLoggedIn] = useState(false)

    const googleID = localStorage.getItem("G_ID");

    useEffect(() => {

        if (googleID == null)
            navigate('/iniciar-sesion');

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + `/get-user/${googleID}`, {headers})
            .then(data => {

                if (data == null)
                    navigate('/iniciar-sesion');

                setUser(data.data.user);
                setLoggedIn(true);
            })
            .catch(error => {
                navigate('/iniciar-sesion');
            });

        if (user != null) {

            //Update Local Storage
            localStorage.removeItem("user");
            localStorage.setItem("user", JSON.stringify(user));
            navigate('/admin/estadisticas')

            if (user.role !== 'A') {
                navigate('/')
            }
        }

    }, [isLoggedIn]);

    return (
        <>
            {isLoggedIn ?
                <Sidebar/>
                :
                <div className="container mx-auto h-screen flex justify-center items-center">
                    <CgSpinner className="w-8 h-8 animate-spin text-amber-400"/>
                </div>
            }
        </>
    );
}

export default Admin;